import React from 'react';
import { getIframeBaseUrl } from '../api';
export const Dinosure = () => (
  <iframe style={{ height: 'calc(100vh - 30px - 82px)', width: '100%' }} src={getIframeBaseUrl()}></iframe>
);
